// extracted by mini-css-extract-plugin
export default {"container":"About_container__Qoj7B","requireView":"About_requireView__TWFys","primary":"About_primary__QNDn8","videoContainer":"About_videoContainer__YYsP+"};